/**
 * Route middleware guard for the payment page.
 *
 * Validates that registration data exists and the subscription selection is valid
 * before entering the payment step.
 *
 * Redirects to the plans page otherwise.
 */
export default defineNuxtRouteMiddleware(() => {
  const registrationStore = useRegistrationStore();
  const selectionStore = useSubscriptionSelectionStore();

  const hasRegistrationData = Object.keys(registrationStore.registrationData).length > 0;
  if (hasRegistrationData && selectionStore.isValid) return;

  const localePath = useLocalePath();
  return navigateTo(localePath({ name: 'plans' }));
});
